// EmployeeListAttendance.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrashAlt,
  faUserPen,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import * as XLSX from "xlsx";
import { useParams } from "react-router-dom";
import { viewerDisabledProps } from "../utils/permissions";
const EmployeeListAttendance = () => {
  const { date, id } = useParams();
  const [employees, setEmployees] = useState([]);
  const [initialEmployees, setInitialEmployees] = useState([]);
  const [searchField, setSearchField] = useState("emp_name");
  const [searchTerm, setSearchTerm] = useState("");
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [attendanceData, setAttendanceData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [previewImage, setPreviewImage] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const itemsPerPage = 10;
  const calculateSpentTime = (entry, exit) => {
    const entryTime = new Date(entry);
    const exitTime = new Date(exit);
    const diffMs = exitTime - entryTime;
    const diffHrs = diffMs / (1000 * 60 * 60); // convert ms to hours
    const hours = Math.floor(diffHrs);
    const minutes = Math.floor((diffHrs % 1) * 60);
  
    return {
      totalHours: diffHrs,
      display: `${hours}h ${minutes}m`
    };
  };
  const navigate = useNavigate();
  const formatDisplayDate1 = (date) => {
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };
  
  // Format date to "YYYY-MM-DD" for API
  const formatAPIDate1 = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    const formattedDate = formatAPIDate1(currentDate);
    console.log(formattedDate,'sddskflj');
    axios
      .get(
        `https://ims-attendanceback.indevconsultancy.in/api/attendance-detail-master/?serchdate=${formattedDate}&id=${id}`
      )
      .then((response) => {
       // console.log(response.data);
        if (response.data) {
          setEmployees(response.data);
          setInitialEmployees(response.data);
        }
        
      })
      .catch((error) => {
        console.error("Error fetching employee data:", error);
      });
  }, [currentDate]);
  console.log(initialEmployees);
  useEffect(() => {
    fetchAttendance();
  }, [month]);
  

  
   


  const fetchAttendance = async () => {
    // TODO: Replace this with actual API
    // Demo data for example
    const sampleData = [
      { id: 1, emp_name: "John Doe", status: "present", date: "2025-06-10" },
      { id: 2, emp_name: "Jane Smith", status: "absent", date: "2025-06-12" },
      { id: 1, emp_name: "John Doe", status: "present", date: "2025-06-15" },
    ];
    const filtered = sampleData.filter((d) => d.date.startsWith(month));
    setAttendanceData(filtered);
  };

  const handleEdit = (id) => {
    alert(`Edit employee with ID: ${id}`);
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this employee?")) {
      const updated = employees.filter((emp) => emp.id !== id);
      setEmployees(updated);
      setInitialEmployees(updated);
    }
  };

  const handleSearch = () => {
    if (!Array.isArray(initialEmployees)) {
      console.warn("initialEmployees is not ready yet");
      return;
    }
  
    const filtered = initialEmployees.filter((emp) =>
      (emp[searchField] || "")
        .toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    );
  
    setEmployees(filtered);
    setCurrentPage(1);
  };

  const handleReset = () => {
    setSearchTerm("");
    setEmployees(initialEmployees);
    setCurrentPage(1);
  };
  // const convertToIndianTime = (utcString) => {
  //   const date = new Date(utcString);
  //   const options = {
  //     timeZone: "Asia/Kolkata",
  //     hour12: false,
  //   };
  //   const indianTime = date.toLocaleString("en-GB", options);
  //   const [ddmmYYYY, time] = indianTime.split(", ");
  //   const [dd, mm, yyyy] = ddmmYYYY.split("/");
  //   return `${yyyy}-${mm}-${dd} ${time}`;
  // };

  const formatDateTimeWithAmPm = (utcString) => {
    const date = new Date(utcString);
    const options = {
      timeZone: "Asia/Kolkata",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  };
  
  console.log(formatDateTimeWithAmPm("2025-07-09T04:53:21Z"));

  const exportToExcel = async () => {
    try {
      const response = await fetch(
        "https://ims-attendanceback.indevconsultancy.in/api/createexcelreport",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Add auth headers if required
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      // Get the response as a Blob (Excel file)
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // Create a link and click it
      const a = document.createElement("a");
      a.href = url;

      // You can set any file name you want
      a.download = "exported_data.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Revoke the object URL after use
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading Excel:", error);
      alert("Error downloading the Excel file. Please try again.");
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = employees.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(employees.length / itemsPerPage);

  const changePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };




   



  const formatDisplayDate = (date) => {
    return date.toLocaleDateString('en-US', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };
  // const [currentDate, setCurrentDate] = useState(new Date());
  // Format date to "YYYY-MM-DD" for API
  const formatAPIDate = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const dateParam = formatAPIDate(currentDate);
    //fetchData(dateParam);
  }, [currentDate]);


  const goToPreviousDay = () => {
    const prev = new Date(currentDate);
    prev.setDate(prev.getDate() - 1);
    setCurrentDate(prev);
  };
  
  const goToNextDay = () => {
    const next = new Date(currentDate);
    next.setDate(next.getDate() + 1);
    setCurrentDate(next);
  };


  return (
    <div className="px-3 py-3 bg-cream" style={{ minHeight: "100%" }}>
      <div className="card">
        <div className="card-header bg-skyBlue text-white">
          <h5 className="mb-0">Employee List</h5>
        </div>
        <div className="card-body">
          <div className="row g-2 g-md-3 align-items-center mb-3">
          
            <div className="col-12 col-md-8">
              <input
                type="text"
                className="form-control"
                placeholder="search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-6 col-md-2">
              <button className="btn btn-primary w-100" onClick={handleSearch}>
                Search
              </button>
            </div>
            <div className="col-6 col-md-2">
              <button className="btn btn-secondary w-100" onClick={handleReset}>
                Reset
              </button>
            </div>
          </div>

          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
            <h6 className="mb-0 text-nowrap">
              Total Employees: <strong>{employees.length}</strong>
            </h6>

            <div className="d-flex flex-column flex-sm-row gap-2 w-100 justify-content-sm-end mt-2 mt-md-0">
              <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-2">
                <button onClick={goToPreviousDay} className="badge bg-secondary">
                  Previous
                </button>
                <h6 className="mb-0 text-nowrap">
                  Date: {formatDisplayDate(currentDate)}
                </h6>
                <button onClick={goToNextDay} className="badge bg-secondary">
                  Next
                </button>
                </div>
              <button
                className="btn btn-primary bg-skyBlue text-nowrap"
                onClick={() => navigate("/employeeForm")}
                {...viewerDisabledProps()}
              >
                Add Employee
              </button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="table table-bordered table-striped text-center">
              <thead className="table-light">
                <tr>
                  <th>S.No</th>
                  <th>Employee Name</th>
                  <th>Employee Code</th>
                  <th>Entry Time</th>
                  <th>Exit Time</th>
                  <th>Time Spend</th>
                  <th>Entry Image</th>
                  <th>Exit Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length === 0 ? (
                  <tr>
                    <td colSpan="9">No employees found.</td>
                  </tr>
                ) : (
                  currentItems.map((emp, index) => {
                    const statusForEmployee = attendanceData.filter(
                      (a) => a.emp_name === emp.emp_name
                    );
                    const presentDays = statusForEmployee.filter(
                      (a) => a.status === "present"
                    ).length;
                    const absentDays = statusForEmployee.filter(
                      (a) => a.status === "absent"
                    ).length;

                    return (
                      <tr key={emp.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>{emp.emp_name}</td>
                        <td>{emp.emp_code || "-"}</td>
                        <td>
                          {emp.entry_time
                            ? formatDateTimeWithAmPm(emp.entry_time)
                            : "-"}
                        </td>
                        <td>
                          {emp.exit_time
                            ? formatDateTimeWithAmPm(emp.exit_time)
                            : "-"}
                        </td>
                        <td
                          style={{
                            color:
                              emp.entry_time && emp.exit_time
                                ? calculateSpentTime(emp.entry_time, emp.exit_time).totalHours >= 8
                                  ? 'green'
                                  : 'red'
                                : 'inherit'
                          }}
                        >
                          {emp.entry_time && emp.exit_time
                            ? calculateSpentTime(emp.entry_time, emp.exit_time).display
                            : '-'}
                        </td>

                        <td>
  {emp.entryimage ? (
    <img
      src={emp.entryimage}
      alt="Entry"
      height="40"
      width="60"
      style={{ objectFit: "cover", cursor: "pointer" }}
      onClick={() => setPreviewImage(emp.entryimage)}
    />
  ) : (
    "-"
  )}
</td>
<td>
  {emp.exitimage ? (
    <img
      src={emp.exitimage}
      alt="Exit"
      height="40"
      width="60"
      style={{ objectFit: "cover", cursor: "pointer" }}
      onClick={() => setPreviewImage(emp.exitimage)}
    />
  ) : (
    "-"
  )}
</td>

                        <td>
                          <button
                            className="btn btn-sm btn-info text-white"
                            onClick={() =>
                              navigate(`/employee-details/${emp.empdetailsid}`, {
                                state: { employee: emp },
                              })
                            }
                          >
                            <FontAwesomeIcon icon={faEye} />
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>

            <nav
              className="mt-3 d-flex justify-content-center"
              aria-label="Pagination"
            >
              <ul className="pagination">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage - 1)}
                  >
                    Previous
                  </button>
                </li>
                {[...Array(totalPages)].map((_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => changePage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => changePage(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="card-footer text-muted text-center small">
          Technology Partner: Indev Consultancy ©2025
        </div>
      </div>

      {previewImage && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    onClick={() => setPreviewImage(null)}
  >
    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
      <div className="modal-content">
        <div className="modal-body text-center">
          <img src={previewImage} alt="Preview" className="img-fluid rounded" />
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default EmployeeListAttendance;
